import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {tabletAndUp} from '../../../../../constants/customMedia';
import {DeliverySectionHeader} from './DeliverySectionHeader';
import {DeliverySectionInfoText} from './DeliverySectionInfoText';

interface DeliverySectionProps {
  className?: string;
  headline: string;
  deliveryDate?: string;
  hideInfoText?: boolean;
  withoutBottomGap?: boolean;
  withoutRoundedBottomCorners?: boolean;
  withoutRoundedTopCorners?: boolean;
  hightlightDateLabel?: boolean;
  shippedBy?: string;
}

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 * Do not take inspiration from this component for new implementations.
 */
export const DeliverySection: FC<
  React.PropsWithChildren<DeliverySectionProps>
> = ({
  className,
  children,
  headline,
  deliveryDate,
  hideInfoText,
  withoutBottomGap,
  withoutRoundedTopCorners,
  withoutRoundedBottomCorners,
  hightlightDateLabel,
  shippedBy,
}) => {
  return (
    <Wrapper
      data-testid="deliverySectionContainer"
      className={className}
      $withoutBottomGap={withoutBottomGap}
      $withoutRoundedBottomCorners={withoutRoundedBottomCorners}
      $withoutRoundedTopCorners={withoutRoundedTopCorners}
    >
      <DeliverySectionHeader
        headline={headline}
        deliveryDate={deliveryDate}
        hightlightDateLabel={hightlightDateLabel}
        shippedBy={shippedBy}
      />
      {children}
      {!hideInfoText && <DeliverySectionInfoText />}
    </Wrapper>
  );
};

const Wrapper = styled.div<{
  $withoutBottomGap?: boolean;
  $withoutRoundedTopCorners?: boolean;
  $withoutRoundedBottomCorners?: boolean;
}>`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.White};
  border-bottom: 1px solid ${COLORS.Grey3};

  gap: 16px;
  padding-block: 16px;

  ${tabletAndUp(
    css`
      gap: 24px;
      padding-block: 24px;
    `,
  )}

  ${({
    $withoutBottomGap,
    $withoutRoundedBottomCorners,
    $withoutRoundedTopCorners,
  }) =>
    tabletAndUp(
      css`
        border: 1px solid ${COLORS.Grey3};
        border-radius: 4px;
        margin-bottom: 14px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04),
          0 10px 15px 0 rgba(0, 0, 0, 0.04);
        ${$withoutBottomGap &&
        css`
          border-bottom: unset;
          margin-bottom: unset;
        `}
        ${$withoutRoundedTopCorners &&
        css`
          border-top-right-radius: unset;
          border-top-left-radius: unset;
        `}
      ${$withoutRoundedBottomCorners &&
        css`
          border-bottom-right-radius: unset;
          border-bottom-left-radius: unset;
        `}
      `,
    )}
`;
